import {UserCurrentBranch} from "../../components";

export const CurrentBranchPage = () => {
    return <UserCurrentBranch/>
};